import React, { useState, useEffect } from "react";

import { OrganizationChart } from "primereact/organizationchart";

import "./style.scss";

const OrgChart = ({ questionModel, questions, setQuestions, open, setOpen, onClick = () => {}, setChartData = () => {}, chartData }) => {

    useEffect(() => {
        if (questions) {
            const ids = new Set();
            const newArr = questions
                .sort((a, b) => a.lvl - b.lvl)
                .reduce((acc, it) => {
                    const func = (item) => {
                        if (item) {
                            if (ids.has(item._id)) return null;
                            ids.add(item._id);
                            const model = [
                                {
                                    label: item.type === "geo" ? geo[item.typeQuestions] : item.question,
                                    expanded: true,
                                    children: item.type === "geo" ? [] : item?.options?.map((o) => ({
                                        label: o.text,
                                        expanded: true,
                                        children: func(questions.filter((i) => i._id === o.relaitedId)?.[0] || null),
                                        _id: item._id,
                                    })),
                                    _id: item._id,
                                },
                            ];

                            return model;
                        }

                        return null;
                    };

                    const orgItem = func(it);
                    if (orgItem) acc.push(orgItem);

                    return acc;
                }, []);

            setChartData(newArr);
        }
    }, [questions]);

    const handleClick = (e) => {
        onClick(e.data);
    };

    const nodeTemplate = (node) => {
        return <div className={`org-chart__question ${node?.children?.length > 1 ? "" : "cyan"}`}>{node.label}</div>;
    };

    return chartData.length ? (
        <div className="org-chart">
            {chartData.map((i, idx) => (
                <OrganizationChart selectionMode="single" nodeTemplate={nodeTemplate} key={idx} value={i} onSelectionChange={handleClick} />
            ))}
        </div>
    ) : null;
};

export default OrgChart;

const geo = { region: "Регион", metro: "Станция метро", city: "Город" };
